// export async function getDataStaffBonusReport(params: string) {
//     if (!params) {
//         console.warn("No params provided, skipping request");
//         return null;
//     }
//
//     try {
// console.log(params,'params')
//         const urlParams = new URLSearchParams(params);
//         const body: Record<string, string | string[]> = {};
//
//
//         for (const [key, value] of urlParams?.entries()) {
//
//             if (key.endsWith("[]")) {
//                 const baseKey = key.slice(0, -2);
//                 if (!body[baseKey]) {
//                     body[baseKey] = [];
//                 }
//                 if (value) {
//                     (body[baseKey] as string[]).push(value);
//                 }
//             } else {
//                 body[key] = value;
//             }
//         }
//
//         console.log("Request body:", body);
//
//         const response = await fetch(
//             "/internal-api/employee/statistics/report/positions/bonus",
//             {
//                 method: "POST",
//                 headers: {
//                     Accept: "application/json",
//                     "Content-Type": "application/json",
//                 },
//                 credentials: "include",
//                 body: JSON.stringify(body),
//             }
//         );
//
//         if (!response.ok) {
//             throw new Error(`HTTP error! Status: ${response.status}`);
//         }
//         const data = await response.json();
//         return data;
//     } catch (error) {
//         console.error("Ошибка: ", error);
//     }
// }

export async function getDataStaffBonusReport(params: string) {
  if (params) {
    try {
      const response = await fetch(
        `/internal-api/employee/statistics/report/positions/bonus?${params}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Ошибка: ", error);
    }
  }
}
